<template>
  <div class="login-header">
    <img src="@/assets/img/logo.png" alt/>
    <div class="header-right">
      <span class="name">智蛛AI</span>
      <span>有“智”者，事竟成</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "LoginHeader",
}
</script>

<style scoped>
.login-header {
  width: 200px;
  height: 66px;
  margin-top: 31px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.login-header img {
  width: 54px;
}

.header-right {
  width: 130px;
  height: 56px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.name {
  font-size: 22px;
  font-family: PingFang-SC-Heavy, PingFang-SC;
  font-weight: 800;
  color: rgba(255, 255, 255, 1);
  line-height: 37px;
}
</style>